import { useState } from 'react';
import { WithAlert } from '@components/design';

const WarningBrandsContainer: React.FC = () => {
  const [isDismissWarning, setIsDismissWarning] = useState<boolean>(false);

  return !isDismissWarning ? (
    <div className="my-4">
      <WithAlert
        title="Your brand selection has been removed due to containing more than the maximum 10 brands
          possible in this view."
        onClick={() => setIsDismissWarning(true)}
      />
    </div>
  ) : null;
};

export default WarningBrandsContainer;
